<p-toast position="top-right" key="maintoast"></p-toast>
<!-- <app-spinner></app-spinner> -->
<app-layout [logoUrl]="'assets/images/logo/saraplus_logo_menu.png'">
  <router-outlet></router-outlet>
</app-layout>
<p-scrollTop [buttonProps]="{ rounded: true, severity: 'contrast' }" [threshold]="100" icon="pi pi-arrow-up" styleClass="right-0 ml-2"></p-scrollTop>
@if (loadSpinner) {
  <p-blockUI [blocked]="true" styleClass="app-loading-overlay">
    <p-progressSpinner ariaLabel="loading"></p-progressSpinner>
  </p-blockUI>
}

<router-outlet name="standalone"></router-outlet>

<p-dialog header="Browser Navigation Not Supported" [modal]="true" [(visible)]="backButtonDialog"
  [breakpoints]="{ '5550px': '50vw','575px': '90vw' }" styleClass="w-full md:w-6 lg:w-4 back-modal border-round-3xl" closable="false">
  <div class="flex flex-column gap-3">
    <div class="flex flex-column mt-3">
      <span>Please do not use browser tools to process this request. If you need to cancel the order, use the designated
      buttons provided within SARA Plus. This ensures accuracy and proper tracking of all actions. Thank you!</span>
    </div>
    <div class="flex flex-1 gap-3 justify-content-end">
      <p-button label="OK" styleClass="p-button-raised" (click)="backButtonDialog = false" rounded="true"></p-button>
    </div>
  </div>
</p-dialog>